import InputTypes from '../../../core/enums/InputTypes';

const ignoreExport = ['contaAcessoCadastro', 'dataCadastro'];

const inputsHistoricoVersoes = [
    {
        name: 'versao',
        label: 'Versão',
        type: InputTypes.FLOAT,
        table: {
            use: true,
            nameUse: 'proposta.numrVersao',
        },
    },
    {
        name: 'tipoValidacaoMetodologica',
        label: 'Tipo',
        type: InputTypes.ENTITY,
        table: {
            use: true,
            nameUse: 'tipoValidacaoMetodologica.descTipoValidacaoMetodologica',
        },
    },
    {
        name: 'dataCadastro',
        label: 'Data',
        type: InputTypes.DATE,
        table: { use: true },
    },
    {
        name: 'analistaMetodologico',
        label: 'Analista Metodológico',
        type: InputTypes.ENTITY,
        table: {
            use: true,
            nameUse: 'proposta.avaliacaoMetodologica.responsavelAnalise.nomePessoa',
        },
    },
    {
        name: 'analistaNegocial',
        label: 'Analista Negocial',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'proposta.avaliacaoNegocial.responsavelAnalise.nomePessoa' },
    },
    {
        name: 'codigoProposta',
        label: 'Cód. Proposta',
        type: InputTypes.ENTITY,
        table: {
            use: true,
            nameUse: 'proposta.id',
        },
    },
    {
        name: 'TipoProposta',
        label: 'Tipo Proposta',
        type: InputTypes.ENTITY,
        table: {
            use: true,
            nameUse: 'proposta.tipoProposta.descTipoProposta',
        },
    },
    {
        name: 'nmIndicador',
        label: 'Nome do Indicador',
        type: InputTypes.STRING,
        table: {
            use: true,
            nameUse: 'proposta.nmIndicador',
        },
    },
    {
        name: 'tipoIndicador',
        label: 'Tipo do Indicador',
        type: InputTypes.ENTITY,
        table: {
            use: true,
            nameUse: 'indicador.tipoIndicador.descTipoIndicador',
        },
    },
    {
        name: 'responsavel',
        label: 'Responsável',
        type: InputTypes.ENTITY,
        table: {
            use: true,
            nameUse: 'indicador.responsavel.nomePessoa',
        },
    },
].map((input) => ({
    ...input,
    export:
        input?.table?.use && !ignoreExport.includes(input?.name) ? input?.table : { use: false },
}));

const inputsHistoricoSituacoes = [
    {
        name: 'dataCadastro',
        label: 'Data e Hora',
        type: InputTypes.DATE,
        table: { use: true },
    },
    {
        name: 'contaAcessoCadastro',
        label: 'Usuário',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'contaAcessoCadastro.nome' },
    },
    {
        name: 'situacaoIndicador',
        label: 'Situação',
        type: InputTypes.ENTITY,
        table: {
            use: true,
            nameUse: 'situacaoIndicador.descSituacaoIndicador',
        },
    },
    {
        name: 'versao',
        label: 'Versão do Indicador',
        type: InputTypes.FLOAT,
        table: {
            use: true,
            nameUse: 'numrVersao',
        },
    },
    {
        name: 'descAcaoExecutada',
        label: 'Ação Executada',
        type: InputTypes.STRING,
        table: {
            use: true,
            nameUse: 'descAcaoExecutada',
        },
    },
    {
        name: 'descJustificativa',
        label: 'Justificativa',
        type: InputTypes.STRING,
        table: {
            use: true,
            nameUse: 'descJustificativa',
        },
    },
].map((input) => ({
    ...input,
    export:
        input?.table?.use && !ignoreExport.includes(input?.name) ? input?.table : { use: false },
}));

export { inputsHistoricoVersoes, inputsHistoricoSituacoes };
